module.exports = __webpack_public_path__ + "img/pageinteriors_empresas-y-corporativos-06vida-grupo.cc72b4c8.jpg";